import React from 'react';
import Reveal from 'react-reveal';
import Layout from "../components/layouts";
import { Parallax } from 'react-parallax';
import carpoolHeader from "../images/carpoolchella-design-contest-header.png";
import carpoolGallery4 from "../images/carpool-gallery-4.jpg";
import carpoolGallery6 from "../images/carpool-gallery-6.jpg";
import carpoolGallery7 from "../images/carpool-gallery-7.jpg";
import carpoolGallery9 from "../images/carpool-gallery-12.jpg";
import carpoolGallery10 from "../images/carpool-gallery-11.jpg";
const Carpool = () => {
  return (
    <Layout navBg>
    <div className="carpoolchella-page">
        <Parallax className="page-header" bgImage={carpoolHeader} strength={400}>
            <div style={{height: '100vh', maxHeight: '550px'}}>
                <div className="page-header-overlay" />
                <h1 className="page-header-title white">Carpoolchella Design Contest</h1>
            </div>
        </Parallax>
        <div className="carpoolchella-inner">
          <div className="carpoolchella-description">
              <h1>Coachella Carpooling Design Challenge</h1>
              <p>
                Attention Coachella Campers, let everyone know you&rsquo;re on the road to Coachella!{'  '}
                Show off your creative side by decorating your car and promoting carpooling on your way to the festival, and
                you could win VIP pass upgrades or other prizes.
              </p>
              <p>
                Carpooling saves gas, time, money, and emissions. It&rsquo;s also a perfect opportunity to roll with your
                favorite people in the world to Coachella.
              </p>
              <p>
                Your proposed car design will be judged based on creativity, originality, feasibility, and safety. One lucky
                Coachella attendee (and their co-pilots) will receive VIP pass upgrades for their festival weekend. To enter,
                post your car photo on Instagram or TikTok using the hashtag #CarpoolchellaDesign, and include your on-site
                location by Thursday at 11:59 pm PST. You can also submit your car photo in the form below. The winning car
                will be announced on Friday morning at 10:00 am PST.
              </p>
              <p>
                This design challenge is separate from the Carpoolchella program. For more information on Carpoolchella and how
                to participate, visit the <a href="https://coachella.com/carpoolchella" target="_blank" rel="noopener noreferrer">Carpoolchella webpage</a>.
              </p>
          </div>
          <div className="carpoolchella-body">
            <img src={carpoolGallery10} />
        </div>
      </div>

      <Reveal effect="animated fadeIn">

        <div className="carpoolchella-inner">
        <div className="carpoolchella-body reverse">
            <img className="carpoolchella-dd-logo" src={carpoolGallery6} />
            </div>
          <div className="carpoolchella-description reverse">
            <h1>How Do I Enter?</h1>
            <p>Simply fill out the <a href="#form">application form</a> below. Also remember to post your concept on Instagram/TikTok/Facebook to encourage others to carpool.</p>
            <p>Good Luck and Happy Carpooling!</p>
            <p>Read the <a href="/contest-rules" target="_blank">Official Rules</a></p>
            <p>Any questions? Contact us at <a href="mailto:pb@globalinheritance.org">pb@globalinheritance.org</a>.</p>
          </div>
        </div>
        </Reveal>
        

        <div className="carpoolchella-inner" style={{ marginTop: 100 }}>
          <Reveal effect="animated fadeIn">
            <div className="carpoolchella-gallery">
              <div className="carpoolchella-ex">
                <img src={carpoolGallery7} />
              </div>
              <div className="carpoolchella-ex">
                <img src={carpoolGallery4} />
              </div>
              <div className="carpoolchella-ex">
                <img src={carpoolGallery9} />
              </div>
            </div>
          </Reveal>
        </div>
        <div id="form" style={{ width: '100%', maxWidth: 780, margin: '0 auto' }}>
        <iframe className="airtable-embed" src="https://airtable.com/embed/appbKAdb2AoFy0IjM/pagV5tFs30gICsqrR/form" frameBorder="0" width="100%" height="533"></iframe>
        </div>
    </div>
    </Layout>
);
}

export default Carpool;
